module.exports = __webpack_public_path__ + "img/zjm_42.d9a92206.png";